import { render, staticRenderFns } from "./CenterIntro.vue?vue&type=template&id=c82e59ac&scoped=true"
import script from "./CenterIntro.vue?vue&type=script&lang=js"
export * from "./CenterIntro.vue?vue&type=script&lang=js"
import style0 from "./CenterIntro.vue?vue&type=style&index=0&id=c82e59ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82e59ac",
  null
  
)

export default component.exports